import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0afce04b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onMouseover", "onTouchstart", "onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "swiper-pagination"
}

import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import { Autoplay, Pagination } from 'swiper';
import { AutoplayOptions } from 'swiper/types/modules/autoplay';
import 'swiper/swiper-bundle.css';

export default /*#__PURE__*/_defineComponent({
  __name: 'Swiper',
  props: {
    list: null,
    type: null,
    slidesPerView: null,
    spaceBetween: null,
    autoplay: null,
    pagination: null,
    grabCursor: { type: Boolean },
    loop: { type: Boolean }
  },
  emits: ['updateYoutube', 'playVideo'],
  setup(__props: any) {



const modules = [Autoplay, Pagination];
const checkIsUrl = (url: any) => {
  if (/^https?:\/\//.test(url)) {
    return true;
  }
  return false;
};
const checkUrlisYoutube = (url: any) => {
  if (url.includes('youtu')) {
    return true;
  }
  return false;
};
const getVideoId = (url: any) => {
  let arr;
  if (/^https:\/\/youtu.be\//.test(url)) {
    arr = url.split('/');
  } else {
    arr = url.split('=');
  }
  const id = arr[arr.length - 1];
  return id;
};
const rotate90Swiper = function (swiper: any, optIsRotate90: boolean) {
  let isRoate90 = !!optIsRotate90;
  swiper.___touches = {};
  swiper.___touches.currentX = swiper.touches.currentX;
  Object.defineProperty(swiper.touches, 'currentX', {
    set: function (v) {
      if (!isRoate90) {
        swiper.___touches.currentX = v;
      } else {
        swiper.___touches.currentY = v;
      }
    },
    get: function () {
      return swiper.___touches.currentX;
    },
  });
  swiper.___touches.currentY = swiper.touches.currentY;
  Object.defineProperty(swiper.touches, 'currentY', {
    set: function (v) {
      if (!isRoate90) {
        swiper.___touches.currentY = v;
      } else {
        swiper.___touches.currentX = v;
      }
    },
    get: function () {
      return swiper.___touches.currentY;
    },
  });
  return function (isRotate90: boolean) {
    isRoate90 = isRotate90;
  };
};
let setRotate90: (isRotate90: boolean) => void;
const checkOrientation = () => {
  if (window.matchMedia('(orientation: portrait)').matches) {
    setRotate90(true);
  } else {
    setRotate90(false);
  }
};
function onSwiper(swiper: any) {
  setRotate90 = rotate90Swiper(swiper, false);
  checkOrientation();
  window.addEventListener('resize', checkOrientation);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Swiper), {
      slidesPerView: __props.slidesPerView,
      spaceBetween: __props.spaceBetween,
      autoplay: __props.autoplay,
      pagination: __props.pagination,
      grabCursor: __props.grabCursor,
      loop: __props.loop,
      modules: modules,
      onSwiper: onSwiper
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
            default: _withCtx(() => [
              (item.url)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (checkUrlisYoutube(item.url))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          onMouseover: ($event: any) => (_ctx.$emit('updateYoutube', getVideoId(item.url))),
                          onTouchstart: ($event: any) => (_ctx.$emit('updateYoutube', getVideoId(item.url))),
                          onClick: ($event: any) => (_ctx.$emit('playVideo', getVideoId(item.url)))
                        }, [
                          _createElementVNode("img", {
                            class: _normalizeClass(__props.type),
                            src: item.img,
                            alt: ""
                          }, null, 10, _hoisted_2)
                        ], 40, _hoisted_1))
                      : (checkIsUrl(item.url))
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: item.url,
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, [
                            _createElementVNode("img", {
                              class: _normalizeClass(__props.type),
                              src: item.img,
                              alt: ""
                            }, null, 10, _hoisted_4)
                          ], 8, _hoisted_3))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 2,
                            class: _normalizeClass(__props.type),
                            src: item.img,
                            alt: ""
                          }, null, 10, _hoisted_5))
                  ], 64))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: _normalizeClass(__props.type),
                    src: item.img,
                    alt: ""
                  }, null, 10, _hoisted_6)),
              (__props.type === 'banner' && index === 0)
                ? _renderSlot(_ctx.$slots, "play", { key: 2 })
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 3
    }, 8, ["slidesPerView", "spaceBetween", "autoplay", "pagination", "grabCursor", "loop"]),
    (__props.pagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
      : _createCommentVNode("", true)
  ], 64))
}
}

})